<span>{{ 'commons.messages.update.notification' | translate }}</span>
<div class="mat-simple-snackbar-action">
  <button mat-button class="action" (click)="action()">
    {{ 'commons.btn.refresh' | translate }}
  </button>
  <button mat-button (click)="dismiss()">
    {{ 'commons.btn.dismiss' | translate }}
  </button>
</div>
